
function render(sourceDom) {
    const SLIDER = 'product-slider';
    const TEMPLATE = {
        SWIPER: (slides) =>`<div class="swiper">
                              <div class="swiper-wrapper">
                                ${slides.map(html => `<div class="swiper-slide">${html}</div>`).join('')}
                              </div>
                              <div class="swiper-pagination"></div>
                            </div>`,
        BG: () => `<picture>
                        <source media="(min-width: 320px) and (max-width: 767px)" srcset="/dist/img/article/product-slider-bg-m-img.jpg">
                        <img class="product-slider-bg" src="/dist/img/article/product-slider-bg-img.jpg" alt="" width="1920" height="500">
                    </picture>`
    };
    const slides = Array.from($(sourceDom).find('.about-forms__item'));

    if (!slides.length) return;

    $(sourceDom)
        .wrap(`<div class="${SLIDER}"></div>`)
        .replaceWith(TEMPLATE.SWIPER(slides.map(x => x.innerHTML)));

    const $p = $(".article-detail__info p");

    $(".product-slider")
        .clone()
        .insertAfter($p.length < 3 ? $p[0] : ($p.eq(2).next().is('ol, ul') ? $p.eq(2).next()[0] :$p[2]))
        .prepend(TEMPLATE.BG());

    const swiper = new Swiper('.product-slider .swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        centerInsufficientSlides: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        breakpoints: {
            480: {
                slidesPerView: 'auto',
            }
        }
    });
}


Array.from(document.querySelectorAll('.about-forms__items')).some(dom => render(dom) || true);



// WEBPACK FOOTER //
// ./_src/article.js